import { combineReducers } from 'redux'

import { connectRouter } from 'connected-react-router'
import { History } from 'history'

import auth from './auth/reducer'
import layout from './layout/reducer'
import snackBar from './snack.bar/reducer'
import patient from './patient/reducer'
import followUp from './followUp/reducer'
import users from './users/reducer'
import alert from './alert/reducer'
import report from './report/reducer'

const createRootReducer = (history: History) => combineReducers({
    auth,
    layout,
    router: connectRouter(history),
    snackBar,
    patient,
    followUp,
    users,
    alert,
    report
})

export default createRootReducer
